function validatePayload(
  eventName,
  payload,
) {
  if (!(eventName in EventDefinitions)) {
    console.groupCollapsed(
      `%cTagular: ERROR | Invalid event name "${eventName}"`,
      "background: #BA5632; color: #fff; padding: 3px 6px;",
    );
    console.log(`%c${eventName} is not a valid event name.`, "color: #BA5632");
    console.groupEnd();
    return false;
  }

  return true;
}
